import React, { useEffect } from 'react'
import './styles.sass'
import { Link } from "react-router-dom"
import { decodeStorage, encodeStorage } from '../../functions/storageBase64'
import { useToken } from '../../hooks/useToken'

export function HeaderSimple(props){
    const { 
        pageClass = ""
    } = props

    const darkModeUser = decodeStorage('darkMode')
    const validaToken = useToken({firstActive: true, name: "header Simple"})

    //- Funcion que evalua el dark mode
    function changeMedia(mq){
        if(sessionStorage.getItem('SelectUser') === "true"){
            if(darkModeUser){
                document.body.classList.add('is-dark-mode')
                encodeStorage('darkMode', true)
            }
            else{
                document.body.classList.remove('is-dark-mode')
                encodeStorage('darkMode', false)
            }
        }else{
            if(mq.matches){
                document.body.classList.add('is-dark-mode')
                //encodeStorage('darkMode', true)
                encodeStorage('darkMode', false)
            }
            else{
                document.body.classList.remove('is-dark-mode')
                encodeStorage('darkMode', false)
            }
        }
    }
    //- Efecto que evalua si se encuentra con dark o light mode
    useEffect(()=>{
        const mq = window.matchMedia('(prefers-color-scheme: dark)')
        try{
            mq.addEventListener('change', changeMedia(mq))
        }
        catch(e){
            //console.log('error:',e)
            mq.addListener(changeMedia(mq))
        }
        if(mq.matches){  document.body.classList.add('is-dark-mode') }
        else{ document.body.classList.remove('is-dark-mode') }
    },[])

    // - seleccion dark mode en switch
    useEffect(()=>{
        //console.log(decodeStorage('darkMode'))
        if(window.matchMedia('(prefers-color-scheme: dark)') ){
            if(decodeStorage('darkMode')){ document.body.classList.add('is-dark-mode') }
            else{ document.body.classList.remove('is-dark-mode') }
        }
    },[decodeStorage('darkMode'), window.matchMedia('(prefers-color-scheme: dark)').matches])


    return(
        <header className={`simple ${pageClass}`}>
			<Link to="/" className="logoClaroshop" aria-label="logoClaroshop"></Link>
		</header>
    )
}


export function HeaderHidden(){

    const darkModeUser = decodeStorage('darkMode') 
    //- Funcion que evalua el dark mode
    function changeMedia(mq){
        if(sessionStorage.getItem('SelectUser') === "true"){
            if(darkModeUser){
                document.body.classList.add('is-dark-mode')
                encodeStorage('darkMode', true)
            }
            else{
                document.body.classList.remove('is-dark-mode')
                encodeStorage('darkMode', false)
            }
        }else{
            if(mq.matches){
                document.body.classList.add('is-dark-mode')
                //encodeStorage('darkMode', true)
                encodeStorage('darkMode', false)
            }
            else{
                document.body.classList.remove('is-dark-mode')
                encodeStorage('darkMode', false)
            }
        }
    }
    //- Efecto que evalua si se encuentra con dark o light mode
    useEffect(()=>{
        const mq = window.matchMedia('(prefers-color-scheme: dark)')
        try{
            mq.addEventListener('change', changeMedia(mq))
        }
        catch(e){
            //console.log('error:',e)
            mq.addListener(changeMedia(mq))
        }
        if(mq.matches){  document.body.classList.add('is-dark-mode') }
        else{ document.body.classList.remove('is-dark-mode') }
    },[])

    // - seleccion dark mode en switch
    useEffect(()=>{
        //console.log(decodeStorage('darkMode'))
        if(window.matchMedia('(prefers-color-scheme: dark)') ){
            if(decodeStorage('darkMode')){ document.body.classList.add('is-dark-mode') }
            else{ document.body.classList.remove('is-dark-mode') }
        }
    },[decodeStorage('darkMode'), window.matchMedia('(prefers-color-scheme: dark)').matches])


    return(
        <header className="hidden"></header>
    )
}